import { IconButton, IconButtonProps } from '@chakra-ui/react'
import React from 'react'

import { IconClose } from '~shared-components/icons/brand/IconClose'

export interface ModalCloseButtonProps extends IconButtonProps {
  onClose: () => void
}

export const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  onClose,
  ...rest
}) => (
  <IconButton
    icon={<IconClose h={6} w={6} />}
    onClick={onClose}
    position="absolute"
    right={4}
    top={5}
    {...rest}
  />
)
